import { INotificationTypes } from 'modules/settings/models';
import API from 'services/api';

export const getNotificationTypes = (): Promise<INotificationTypes[]> =>
  API.get('api/root/notificationType/all')?.then(response => response?.data);
